import gql from 'graphql-tag.macro';

export const query = gql`query GetBadges{
  allBadges{
    id
    name
    icon
    type
    description
    requestorRemovable
  }
}`;

const reducer = payload => payload.allBadges;


export const getBadges = {
  query,
  reducer,
};

export default getBadges;
